import React from 'react'
import ContentLoader from 'react-content-loader'

const GridLoader = ({props}) => {
    const cardsPerRow = 4
    const cardOffsetX = 350
    const rowOffsetY = 400

    return (
        <ContentLoader
            width={1450}
            height={rowOffsetY * 2} 
            backgroundColor="#f5f5f5"
            foregroundColor="#dbdbdb"
            {...props}
        >
            <rect x="0" y="0" rx="3" ry="3" width="1" height="900" />
            <rect x="1544" y="0" rx="3" ry="3" width="1" height="900" />
            <rect x="0" y="0" rx="3" ry="3" width="1900" height="1" />
            <rect x="0" y="749" rx="3" ry="3" width="1900" height="1" />

            <rect x="20" y="20" rx="9" ry="9" width="100" height="25" />
            <rect x="20" y="53" rx="6" ry="6" width="200" height="15" />
            <rect x="1240" y="35" rx="9" ry="9" width="100" height="25" />
            <rect x="1350" y="35" rx="9" ry="9" width="100" height="25" />
            
            {Array.from({ length: 2 }).map((_, rowIndex) => {
                const yOffset = rowIndex * rowOffsetY

                return Array.from({ length: cardsPerRow }).map((_, colIndex) => {
                    const xOffset = colIndex * cardOffsetX

                    return (
                        <React.Fragment key={`${rowIndex}-${colIndex}`}>
                            <circle cx={xOffset + 220} cy={yOffset + 205} r="49" />
                            <circle cx={xOffset + 245} cy={yOffset + 240} r="25" />
                            <rect x={xOffset + 75} y={yOffset + 280} rx="9" ry="9" width="300" height="25" />
                            <rect x={xOffset + 145} y={yOffset + 330} rx="9" ry="9" width="150" height="25" />
                            <rect x={xOffset + 90} y={yOffset + 370} rx="9" ry="9" width="250" height="15" />
                            <rect x={xOffset + 145} y={yOffset + 400} rx="9" ry="9" width="150" height="15" />
                            <rect x={xOffset + 170} y={yOffset + 455} rx="9" ry="9" width="120" height="15" />
                            <circle cx={xOffset + 150} cy={yOffset + 460} r="10" />
                        </React.Fragment>
                    )

                })
            })}
            
        </ContentLoader>
    )

};

export default GridLoader;
